import {
  array,
  boolean,
  object,
  pipe,
  string,
  transform,
  union,
  unknown,
} from 'valibot';
import { ArticleBlock, ArticleBlockSchema } from './article-block';
import { IdSchema } from './id-schema';

/**
 * @public
 */
export interface Article {
  /**
   * ID of the article.
   */
  readonly id: string;

  /**
   * Article key.
   */
  readonly key: string;

  /**
   * Article title.
   */
  readonly title: string;

  /**
   * Article blocks.
   */
  readonly blocks: readonly ArticleBlock[];

  /**
   * Whether the article is published.
   */
  readonly isPublished: boolean;
}

/**
 * @internal
 */
export const ArticleSchema = pipe(
  object({
    id: IdSchema,
    key: string(),
    title: string(),
    blocks: array(
      union([
        ArticleBlockSchema,
        pipe(
          unknown(),
          transform(() => null)
        ),
      ])
    ),
    is_published: boolean(),
  }),
  transform(
    (input): Article => ({
      id: input.id,
      key: input.key,
      title: input.title,
      blocks: input.blocks.filter(Boolean),
      isPublished: input.is_published,
    })
  )
);
